import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function AboutSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="w-full aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20desktop%20workspace%20with%20large%20monitor%20displaying%20colorful%20spreadsheet%20interface%20with%20product%20thumbnails%20and%20categories%2C%20surrounded%20by%20fashion%20sneakers%20designer%20bags%20and%20accessories%20on%20warm%20wooden%20desk%2C%20bright%20natural%20daylight%20from%20large%20window%2C%20green%20plant%20in%20corner%2C%20productive%20creative%20atmosphere%2C%20editorial%20tech%20lifestyle%20photography%2C%20warm%20inviting%20tones%2C%20sophisticated%20home%20office%20aesthetic&width=800&height=600&seq=about-kakobuy-2026-v3&orientation=landscape"
                alt="Kakobuy Spreadsheet - baza produktów"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
          <div className="lg:w-1/2">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-5">
              {t('about.title')}
            </h2>
            <p className="text-foreground-600 leading-relaxed mb-4 text-sm md:text-base">
              {t('about.paragraph1')}
            </p>
            <p className="text-foreground-600 leading-relaxed mb-6 text-sm md:text-base">
              {t('about.paragraph2')}
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik-2026"
                className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                Dowiedz się więcej
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/artykul/jak-korzystac-z-kakobuy-spreadsheet"
                className="inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                Poradnik użytkownika
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}